import React, { Component } from 'react';



class BarChartIcon extends Component {

  state = {
    hovered: false
  };

  hover = () => this.setState({ hovered: true });
  unhover = () => this.setState({ hovered: false });


  render() {
    const {
      click,
      fontSize
    } = this.props;
    return (
      <div
        onMouseEnter={this.hover}
        onMouseLeave={this.unhover}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          fontSize: fontSize ? fontSize : null,
          color: this.state.hovered ? '#f26522' : 'rgba(0, 0, 0, 0.8)',
          cursor: 'pointer'
        }}
      >
        <i
          onClick={ click ? click : null }
          className="far fa-chart-bar"
        />
      </div>
    )
  }
}


export default BarChartIcon;


// WEBPACK FOOTER //
// ./src/components/bar-chart-icon/bar-chart-icon-component.js